import { createFileRoute } from "@tanstack/react-router";
import { JOURNAL_KINDS } from "@/components/work/logic";
import { WorkPage, type WorkSearch } from "@/components/work/work-page";

/** A short string from the URL, or nothing. */
const short = (value: unknown, max: number) =>
  typeof value === "string" && value.length > 0 && value.length <= max ? value : undefined;

export const Route = createFileRoute("/_app/$workspaceSlug/work")({
  // Which view is shown, which project is kept, which worktree is open and
  // what the journal is kept to live in the URL and nowhere else. Whatever
  // the URL says, this returns a page that can be drawn: anything it does
  // not know is the whole list, and a worktree that is not there says so.
  validateSearch: (search: Record<string, unknown>): WorkSearch => {
    const project = short(search.project, 64);
    const work = short(search.work, 64);
    const person = short(search.person, 128);
    const kind = JOURNAL_KINDS.find((candidate) => candidate === search.kind);
    return {
      ...(search.view === "journal" ? { view: "journal" as const } : {}),
      ...(project ? { project } : {}),
      ...(work ? { work } : {}),
      ...(person ? { person } : {}),
      ...(kind ? { kind } : {}),
    };
  },
  component: WorkRoute,
});

function WorkRoute() {
  const { workspaceSlug } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <WorkPage
      key={workspaceSlug}
      search={search}
      onSearchChange={(next) => void navigate({ search: next })}
    />
  );
}
